<template>
  <div class="page">
    <p align="center" class="title">
      <b>爪玩隐私权政策</b>
    </p>
    <p align="right" class="time">
      最近更新日期：<span>2020</span>年<span>07</span>月<span>18</span>日
    </p>
    <p align="left">
      <b
        ><span><br /><br /><br /></span
      ></b>
    </p>
    <p align="left">
      <b>提示条款</b>
    </p>
    <p align="left">
      <span>&nbsp;</span>
    </p>
    <p align="left">
      您的信任对我们非常重要，我们深知个人信息对您的重要性，我们将按法律法规要求，采取相应安全保护措施，尽力保护您的个人信息安全可控。鉴于此，<a
      ></a
      ><b>西安偏爱信息技术有限责任公司</b
      >（以下称<span>“</span>爪玩<span>”</span>或<span>“</span>我们<span>”</span>）制定本《爪玩隐私权政策》（以下称<span>“</span>本政策<span>/</span>本隐私权<span>”</span>）并提醒您：<span
      ></span>
    </p>
    <p align="left">
      需要特别说明的是，<b><u>本政策仅适用于爪玩产品及服务，</u></b
      ><b
        ><u><span>&nbsp;</span></u></b
      ><b
        ><u
          >不适用于其他第三方向您提供的服务，第三方向您提供的服务适用其向您说明的隐私权政策。</u
        ></b
      >
    </p>
    <p align="left">
      <b
        ><u
          >在使用爪玩各项产品或服务前，请您务必仔细阅读并透彻理解本政策，特别是以粗体</u
        ></b
      ><b
        ><u><span>/</span></u></b
      ><b
        ><u
          >粗体下划线标识的条款，您应重点阅读，在确认充分理解并同意后再开始使用。</u
        ></b
      >如对本政策内容有任何疑问、意见或建议，您可通过爪玩提供的各种联系方式与我们联系。<span
      ></span>
    </p>
    <p align="left">
      <span>&nbsp;</span>
    </p>
    <p align="left">
      <b>第一部分</b><span>&nbsp;<b>&nbsp;</b>&nbsp;</span><b>定义</b>
    </p>
    <p align="left">
      <b>爪玩：</b>属西安偏爱信息技术有限责任公司移动客户端。<span></span>
    </p>
    <p align="left">
      <b>爪玩服务提供者</b
      >：指爪玩移动客户端及软件技术服务提供者西安偏爱信息技术有限责任公司。
    </p>
    <p align="left">
      <b>关联公司</b>：指<b><u>西安偏爱信息技术有限责任公司</u></b
      >最新披露的爪玩服务提供者的关联公司。
    </p>
    <p align="left">
      <span style="font-weight: bold">微信公司：</span
      >指提供支持微信支付的主体深圳市腾讯计算机系统有限公司。
    </p>
    <p align="left">
      <span _ngcontent-c2="" style="font-weight: bold">高德地图：</span
      ><span _ngcontent-c2="" style="">指提供地图服务的主体</span
      >高德软件有限公司。
    </p>
    <p align="left">
      <span style="font-weight: bold">友盟：</span>
      指提供移动客户端错误手机捕获服务的主体北京锐讯灵通科技有限公司。
    </p>
    <p align="left">
      <b>个人信息</b
      >：指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。<span
      ></span>
    </p>
    <p align="left">
      <b>个人敏感信息</b>：指包括身手机号码，姓名，真实收货地址。<span></span>
    </p>
    <p align="left">
      <b>个人信息删除</b
      >：指在实现日常业务功能所涉及的系统中去除个人信息的行为，使其保持不可被检索、访问的状态。<span
      ></span>
    </p>
    <p align="left"><b>儿童：</b>是指不满十四周岁的未成年人。</p>
    <p align="left">
      <span>&nbsp; &nbsp;</span>除另有约定外，本政策所用定义与<span
        ><b
          ><span><span>《</span></span></b
        ><b
          ><span><span>爪玩</span></span></b
        ><b
          ><span><span>会员服务协议》</span></span></b
        ></span
      >中的定义具有相同的涵义。
    </p>
    <p align="left">
      <span>&nbsp;</span>
    </p>
    <p align="left">
      <span>&nbsp;</span>
    </p>
    <p align="left">
      <b>第二部分</b><span>&nbsp;<b>&nbsp;</b>&nbsp;</span><b>隐私权政策</b>
    </p>
    <p align="left">本隐私权政策部分将帮助您了解以下内容：</p>
    <p align="left">
      <span>1</span>、<span>&nbsp;</span>我们如何收集和使用您的信息<span></span>
    </p>
    <p align="left">
      <span>2</span>、我们如何使用<span>Cookie</span>和同类技术<span></span>
    </p>
    <p align="left">
      <span>3</span>、我们如何共享、转让、公开披露您的信息<span></span>
    </p>
    <p align="left"><span>4</span>、我们如何保护您的信息</p>
    <p align="left"><span>5</span>、您如何管理您的信息</p>
    <p align="left"><span>6</span>、我们如何处理未成年人的信息</p>
    <p align="left"><span>7</span>、您的个人信息如何在全球范围转移</p>
    <p align="left"><span>8</span>、本隐私权政策如何更新</p>
    <p align="left"><span>9</span>、如何联系我们</p>
    <p align="left">
      <span>&nbsp;</span>
    </p>
    <p align="left">
      <b>一、我们如何收集和使用您的信息</b>
    </p>
    <p align="left">
      在您使用我们的产品及<span>/</span>或服务时，我们需要<span>/</span>可能需要收集和使用的您的个人信息包括如下两种：<span
      ></span>
    </p>
    <p align="left">
      <b><span>1</span></b
      ><b>、</b><b><u>为实现向您提供我们产品及</u></b
      ><b
        ><u><span>/</span></u></b
      ><b
        ><u
          >或服务的基本功能，您须授权我们收集、使用的必要的信息。如您拒绝提供相应信息，您将无法正常使用我们的产品及</u
        ></b
      ><b
        ><u><span>/</span></u></b
      ><b><u>或服务；</u></b>
    </p>
    <p align="left">
      <b><span>2</span></b
      ><b>、</b><b><u>为实现向您提供我们产品及</u></b
      ><b
        ><u><span>/</span></u></b
      ><b
        ><u
          >或服务的附加功能，您可选择授权我们收集、使用的信息。如您拒绝提供，您将无法正常使用相关附加功能，但并不会影响您正常使用我们产品及</u
        ></b
      ><b
        ><u><span>/</span></u></b
      ><b><u>或服务的基本功能。</u></b>
    </p>
    <p align="left">
      <b><u>您理解并同意：</u></b>
    </p>
    <p align="left">
      <b><span>1</span></b
      ><b>、</b
      ><b
        ><u
          >我们致力于打造多样的产品和服务以满足您的需求。因我们向您提供的产品和服务种类众多，且不同用户选择使用的具体产品</u
        ></b
      ><b
        ><u><span>/</span></u></b
      ><b><u>服务范围存在差异，相应的，基本</u></b
      ><b
        ><u><span>/</span></u></b
      ><b
        ><u
          >附加功能及收集使用的个人信息类型、范围等会有所区别，请以具体的产品</u
        ></b
      ><b
        ><u><span>/</span></u></b
      ><b><u>服务功能为准</u></b
      ><b>；</b>
    </p>
    <p align="left">
      <b><span>2</span></b
      ><b>、</b
      ><b
        ><u
          >为给您带来更好的产品和服务体验，我们在持续努力改进我们的技术，随之我们可能会不时推出新的或优化后的功能，可能需要收集、使用新的个人信息或变更个人信息使用目的或方式。对此，我们将通过更新本政策、弹窗、页面提示等方式另行向您说明对应信息的收集目的、范围及使用方式，并为您提供自主选择同意的方式，且在征得您明示同意后收集、使用</u
        ></b
      ><b>。</b
      >在此过程中，如果您有任何疑问、意见或建议的，您可通过爪玩提供的各种联系方式与我们联系，我们会尽快为您作出解答。<span
      ></span>
    </p>
    <p align="left">
      <span>&nbsp;</span>
    </p>
    <p align="left">
      我们会为实现本政策下述的各项功能，收集和使用您的个人信息：<span></span>
    </p>
    <p align="left">
      <b>（一）帮助您成为我们的会员</b>
    </p>
    <p align="left">
      我们通过爪玩平台账户为您提供会员服务。为注册成为会员并使用我们的会员服务，您需要提供<b>手机号码、拟使用的会员名和密码</b>用于创建爪玩平台账户。您授权以爪玩平台账号<span>/</span>支付宝账号/微信账号登录爪玩后，我们将根据您的授权获取相关账号的<b>用户标识、登陆名、昵称、头像、姓名以及登陆状态信息</b>。如果您仅需使用浏览、搜索服务，您不需要注册成为我们的会员及提供上述信息。<span
      ></span>
    </p>
    <p align="left">
      <b><u>对于需要爪玩平台账户</u></b
      ><b
        ><u><span>/</span></u></b
      ><b
        ><u
          >支付账户才能使用的服务，我们可能会根据您提供的上述信息校验您的会员身份，确保我们是在为您本人提供服务。</u
        ></b
      >
    </p>
    <p align="left">
      您在使用爪玩时，为维护您的基本资料，改善您的服务体验，<b>您可以完善网络身份识别信息（如头像、昵称、地址等）</b>。
    </p>
    <p align="left">
      我们可能经您同意后向第三方共享您的账户信息<b>（头像、昵称及其他经您同意共享的信息），</b>使您可以实现与第三方账户的登陆或权益互通。此外，我们可能会根据您的授权从第三方处获取您的账户信息，并与您的爪玩账户进行绑定，使您可以通过第三方账户直接登录、使用我们的产品及<span>/</span>或服务或实现账户之间相关权益互通。我们将根据与第三方的约定，在您授权同意范围内使用您的相关信息。
    </p>
    <p align="left">
      <span>&nbsp;</span>
    </p>
    <p align="left">
      <b>（二）为您提供商品或服务信息展示</b>
    </p>
    <p align="left">
      在您使用我们服务过程中，为保障您的账户安全、为识别账号异常状态、了解产品适配性、向您提供更契合您需求的页面展示和搜索结果，我们可能会自动收集您的使用情况并存储为网络日志信息，包括：<span
      ></span>
    </p>
    <p align="left">
      设备信息：我们会根据您在软件安装及<span>/</span>或使用中的具体操作，接收并记录您所使用的设备相关信息（包括设备型号、设备ID、设备MAC地址、操作系统版本、设备设置、唯一设备标识符、设备环境等软硬件特征信息）、设备所在位置相关信息（包括您授权的<span>GPS</span>位置以及<span>WLAN</span>接入点、蓝牙和基站等传感器信息）。<span
      ></span>
    </p>
    <p align="left">
      服务日志信息：当您使用我们的网站或客户端提供的产品或服务时，我们会自动收集您对我们服务的详细使用情况，作为服务日志保存，包括浏览、点击查看、搜索查询、预约、添加至购物车、交易、售后、分享信息、发布信息，以及<span>IP</span>地址、浏览器类型、电信运营商、使用语言、访问日期和时间。<span
      ></span>
    </p>
    <p align="left">
      <b
        ><u
          >请注意，单独的设备信息、服务日志信息是无法识别特定自然人身份的信息。</u
        ></b
      >如果我们将这类非个人信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，则在结合使用期间，这类非个人信息将被视为个人信息，除取得您授权或法律法规另有规定外，我们会将这类信息做匿名化、去标识化处理。<span
      ></span>
    </p>
    <p align="left">
      <b
        ><u
          >为向您提供更便捷、更符合您个性化需求的信息展示、搜索及推送服务，我们会根据您的设备信息和服务日志信息，提取您的偏好特征，并基于特征标签产出间接人群画像，用于展示、推送信息和可能的商业广告。</u
        ></b
      >
    </p>
    <p align="left">
      我们努力保障您的浏览体验。如果您不想接受我们给您发送的商业广告，您可通过短信提示回复退订或我们提供的其他方式进行退订或关闭；在您使用我们提供的站内搜索服务时，我们也同时提供了不针对您个人特征的选项。<span
      ></span>
    </p>
    <p align="left">
      此外，我们也会为了不断改进和优化上述的功能来使用您的上述信息。<span
      ></span>
    </p>
    <p align="left">
      <b>（三）为您提供评论、社区等信息公开发布功能</b>
    </p>
    <p align="left">
      您可通过我们为您提供的评论、社区、直播及其他信息发布功能公开发布信息，包括作为会员可发布图文<span>/</span>视频内容及发表评价。我们将收集您发布的信息，并展示您的用户名、昵称、头像和发布内容。<span
      ></span>
    </p>
    <p align="left">
      <b
        ><u
          >请注意，您公开发布的信息中可能会涉及您或他人的个人信息甚至个人敏感信息，如您在评价时选择上传包含个人信息的图片。请您更加谨慎地考虑，是否在使用我们的服务时共享甚至公开分享相关信息。您公开发布的信息中涉及儿童个人信息的，需在发布前取得所涉及儿童的监护人授权同意。前述情形下监护人有权通过本政策第九条的途径联系我们，要求更正或删除涉及儿童个人信息的内容。</u
        ></b
      >
    </p>
    <p align="left">
      <b><span>&nbsp;&nbsp;</span></b
      ><b>（四）为您提供安全保障</b>
    </p>
    <p align="left">
      为提高您使用我们及我们关联公司、合作伙伴提供服务的安全性，保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入等安全风险，更准确地识别违反法律法规或爪玩相关协议规则的情况，我们在应用程序中嵌入我们关联公司开发的应用安全<span>SDK</span>收集您的设备信息、服务日志信息，并可能使用或整合您的会员信息、交易信息以及我们关联公司、合作伙伴取得您授权或依据法律可共享的信息，来综合判断您账户及交易风险、进行身份验证、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施。<span
      ></span>
    </p>
    <p align="left">
      <span>&nbsp;&nbsp;</span><b>（五）为您提供其他附加服务</b>
    </p>
    <p align="left">
      为向您提供更便捷、更优质、个性化的产品及<span>/</span>或服务，努力提升您的体验，我们在向您提供的以下附加服务中可能会收集和使用您的个人信息。<b
        ><u
          >如果您不提供这些信息，不会影响您使用爪玩的浏览、搜索等基本服务，</u
        ></b
      >但您可能无法获得这些附加服务给您带来的用户体验。这些附加服务包括：<span
      ></span>
    </p>
    <p align="left">
      <span>1</span
      >、基于位置信息的个性化推荐服务：我们会在您开启位置权限后访问获取您的位置信息，根据您的位置信息为您提供更契合您需求的页面展示、产品及<span>/</span>或服务，比如向您推荐附近的爪玩门店产品及<span>/</span>或服务。<span
      ></span>
    </p>
    <p align="left">
      <span>2</span
      >、基于相机<span>/</span>摄像头的附加服务：您可在开启相机<span>/</span>摄像头权限后使用该功能进行扫码用于领取优惠信息，直接拍摄并上传图片用于评价、分享，以及参与活动等您明确知悉的场景。<span
      ></span>
    </p>
    <p align="left">
      <span>3</span
      >、基于相册（图片库<span>/</span>视频库）的图片<span>/</span>视频访问及上传的附加服务：您可在开启相册权限后使用该功能上传您的照片<span>/</span>图片<span>/</span>视频，以实现更换头像、发表评论<span>/</span>分享与客服沟通提供证明等功能。<b
        >我们可能会使用包含您所上传照片或图片的评论信息。</b
      >
    </p>
    <p align="left">
      <span>4</span
      >、基于麦克风的语音技术相关附加服务：您可在开启麦克风权限后使用麦克风实现在社群聊天中使用语音聊天功能，或与客服联系，在这些功能中我们会收集您的<b>录音内容</b>实现语音聊天、或响应您的客服及争议处理等需求。请您知晓，<b
        ><u
          >即使您已同意开启麦克风权限，我们也仅会在您主动点击客户端内麦克风图标或录制视频时通过麦克风获取语音信息。</u
        ></b
      >
    </p>
    <p align="left">
      <a name="OLE_LINK1"></a
      >5、基于电话状态的附加服务：为保障您的账号与使用安全，您需要授权我们读取本机识别码。<span
      ></span>
    </p>
    <p align="left">
      您理解并同意，上述附加服务可能需要您在您的设备中开启您的位置信息<span>&nbsp;</span>（地理位置）、摄像头（相机）、相册（图片库）、麦克风（语音）、通讯录及<span>/</span>或电话状态的访问权限，以实现这些权限所涉及信息的收集和使用。您可在您的设备设置或爪玩移动客户端<span>“</span>我的<span>—</span>设置<span>—</span>隐私设置<span>—</span>系统权限<span>”</span>中查看上述部分权限的状态，并可自行决定这些权限随时的开启或关闭。<b
        >请您注意，您开启任一权限即代表您授权我们可以收集和使用相关个人信息来为您提供对应服务，您一旦关闭任一权限即代表您取消了授权，我们将不再基于对应权限继续收集和使用相关个人信息，也无法为您提供该权限所对应的服务。但是，您关闭权限的决定不会影响此前基于您的授权所进行的信息收集及使用。</b
      >
    </p>
    <p align="left">
      <span>&nbsp;</span>
    </p>
    <p align="left">
      <span>&nbsp;</span>
    </p>
    <p align="left">
      如果您想了解Android端系统功能调用权限的详细情况，请阅读下方的说明列表（iOS端不涉及此项内容）。
    </p>
    <table>
      <tbody>
        <tr>
          <th>权限名称</th>
          <th>解释说明</th>
          <th>使用位置和涉及功能说明</th>
        </tr>
        <tr>
          <td>android.permission.INTERNET</td>
          <td>访问网络权限</td>
          <td>所有需要使用网络调用的位置</td>
        </tr>
        <tr>
          <td>android.permission.RECORD_AUDIO</td>
          <td>访问麦克风权限</td>
          <td>发布语音纸条时录音</td>
        </tr>
        <tr>
          <td>android.permission.VIBRATE</td>
          <td>设备震动权限</td>
          <td>点击操作后震动</td>
        </tr>
        <tr>
          <td>android.permission.ACCESS_NETWORK_STATE</td>
          <td>访问网络状态权限</td>
          <td>友盟统计功能</td>
        </tr>
        <tr>
          <td>android.permission.ACCESS_WIFI_STATE</td>
          <td>访问WiFi状态权限</td>
          <td>友盟统计功能</td>
        </tr>
        <tr>
          <td>android.permission.ACCESS_COARSE_LOCATION</td>
          <td>访问位置信息权限</td>
          <td>精确获取当前位置信息，友盟统计功能</td>
        </tr>
        <tr>
          <td>android.permission.ACCESS_FINE_LOCATION</td>
          <td>访问位置信息权限</td>
          <td>粗略获取当前位置信息，友盟统计功能</td>
        </tr>
        <tr>
          <td>android.permission.READ_EXTERNAL_STORAGE</td>
          <td>本地存储读权限</td>
          <td>上传图片，播放语音时需要判定资源是否存在</td>
        </tr>
        <tr>
          <td>android.permission.WRITE_EXTERNAL_STORAGE</td>
          <td>本地存储写权限</td>
          <td>上传图片，录音，播放语音时需要将资源保存在本地</td>
        </tr>
        <tr>
          <td>android.permission.READ_PHONE_STATE</td>
          <td>读取手机识别码权限</td>
          <td>友盟统计功能</td>
        </tr>
        <tr>
          <td>android.permission.CAMERA</td>
          <td>调用照相机权限</td>
          <td>上传图片或更换头像为拍摄的照片时需要调用照相机权限</td>
        </tr>
        <!-- <tr>
          <td>android.permission.ACCEPT_HANDOVER</td>
          <td>允许呼叫应用继续在另一个应用中启动的呼叫</td>
          <td>上传图片或更换头像为拍摄的照片时需要调用照相机权限</td>
        </tr>
        <tr>
          <td>android.permission.ACTIVITY_RECOGNITION</td>
          <td>允许应用程序识别物理活动</td>
          <td>动态获取权限</td>
        </tr> -->
      </tbody>
    </table>
    <p align="left">
      <span>&nbsp;</span>
    </p>
    <p align="left">
      我们的产品集成友盟+SDK，友盟+SDK需要收集您的设备Mac地址、唯一设备识别码（IMEI/android
      ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI
      信息）以提供统计分析服务，并通过地理位置校准报表数据准确性，提供基础反作弊能力。
    </p>
    <p align="left">
      为了数据统计和分析的目的，我们的产品集成了 openinstall SDK，我们需要向
      openinstall SDK
      共享您的相关个人信息，具体如下表所示。为了您的信息安全，我们已经与第三方
      SDK
      服务商签署严格的数据安全保密协议，这些公司会严格遵守我们的数据隐私和安全要求。为使您更好地了解
      openinstall
      收集的数据类型及用途，以及保护个人信息的方式您可以查看openinstall
      隐私政策进一步了解。您理解并同意，openinstall
      有权对已收集的数据，在保护您个人信息和隐私权以及符合适用法律法规的前提下，进行去标识化或匿名化处理后用于提供数据服务。如果
      openinstall SDK
      收集使用个人信息的目的、方式和范围发生变化时，我们会以适当的方式通知并提醒终端用户。
    </p>
    <table>
      <tbody>
        <tr>
          <th>产品名称</th>
          <th>业务功能</th>
          <th>收集方式</th>
          <th>个人信息类型和字段</th>
          <th>用途和目的</th>
          <th>信息处理方式</th>
        </tr>
        <tr>
          <td>openinstall</td>
          <td>基础服务（携带参数安装，H5渠道统计，应用统计，一键跳转）</td>
          <td>调用系统相关接口自动采集</td>
          <td>设备信息：设备品牌，设备型号，操作系统版本；网络信息：IP地址</td>
          <td>渠道统计；应用统计分析；作弊防护</td>
          <td>
            采用数据加密技术对数据进行传输；采用去标识匿名化方式对信息进行脱敏展示
          </td>
        </tr>
      </tbody>
    </table>
    <p align="left">
      建议参考此表格，向您的用户披露openinstall
      SDK收集使用个人信息的目的、方式和范围。您应知悉和了解，部分设备信息和网络信息需要通过您安装openinstall
      SDK
      的宿主App申请权限，openinstall不主动向用户移动终端申请任何权限，只有在获得用户的授权同意后我们才会进行收集。
    </p>
    <p align="left">
      <span>&nbsp;</span>
    </p>
    <p align="left">
      <b>（六）其他</b>
    </p>
    <p align="left">
      <b
        ><u><span>1</span></u></b
      ><b><u>、若你提供的信息中含有其他用户的个人信息，在向</u></b
      ><b><u>爪玩提供这些个人信息之前，您需确保您已经取得合法的授权。</u></b>
    </p>
    <p align="left">
      <b
        ><u><span>2</span></u></b
      ><b
        ><u
          >、若我们将信息用于本政策未载明的其他用途，或者将基于特定目的收集而来的信息用于其他目的，或者我们主动从第三方处获取您的个人信息，均会事先获得您的同意。</u
        ></b
      >
    </p>
    <p align="left">
      若我们从第三方处间接获取您的信息的，我们会在收集前明确以书面形式要求该第三方在已依法取得您同意后收集个人信息，并向您告知共享的信息内容，且涉及敏感信息的在提供给我们使用前需经过您的明确确认，要求第三方对个人信息来源的合法性和合规性作出承诺，如第三方有违反行为的，我们会明确要求对方承担相应法律责任；同时，我们的专业安全团队对个人信息会进行安全加固（包括敏感信息报备、敏感信息加密存储、访问权限控制等）。我们会使用不低于我们对自身用户个人信息同等的保护手段与措施对间接获取的个人信息进行保护。<span
      ></span>
    </p>
    <p align="left"><span>3</span>、征得授权同意的例外</p>
    <p align="left">
      您充分理解并同意，我们在以下情况下收集、使用您的个人信息无需您的授权同意，且我们可能不会响应您提出的更正<span>/</span>修改、删除、注销、撤回同意、索取信息的请求：<span
      ></span>
    </p>
    <p align="left">（<span>1</span>）与国家安全、国防安全有关的；</p>
    <p align="left">
      （<span>2</span>）与公共安全、公共卫生、重大公共利益有关的；<span></span>
    </p>
    <p align="left">
      （<span>3</span>）与犯罪侦查、起诉、审判和判决执行等司法或行政执法有关的；<span
      ></span>
    </p>
    <p align="left">
      （<span>4</span>）出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；<span
      ></span>
    </p>
    <p align="left">
      （<span>5</span>）您自行向社会公众公开的个人信息；<span></span>
    </p>
    <p align="left">
      （<span>6</span>）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。<span
      ></span>
    </p>
    <p align="left">
      （<span>7</span>）根据与您签订和履行相关协议或其他书面文件所必需的；<span
      ></span>
    </p>
    <p align="left">
      （<span>8</span>）用于维护所提供的产品及<span>/</span>或服务的安全稳定运行所必需的，例如发现、处置产品及<span>/</span>或服务的故障；<span
      ></span>
    </p>
    <p align="left">（<span>9</span>）为合法的新闻报道所必需的；</p>
    <p align="left">
      （<span>10</span>）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；<span
      ></span>
    </p>
    <p align="left">（<span>11</span>）法律法规规定的其他情形。</p>
    <p align="left">
      请知悉，根据适用的法律，若我们<b
        ><u
          >对个人信息采取技术措施和其他必要措施进行处理，使得数据接收方无法重新识别特定个人且不能复原</u
        ></b
      >，或我们可能会对收集的信息进行去标识化地研究、统计分析和预测，用于改善爪玩的内容和布局，为商业决策提供产品或服务支撑，以及改进我们的产品和服务（包括使用匿名数据进行机器学习或模型算法训练），<b
        ><u>则此类处理后数据的使用无需另行向您通知并征得您的同意</u></b
      >。
    </p>
    <p align="left">
      <span>4</span
      >、如我们停止运营爪玩产品或服务，我们将及时停止继续收集您个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知您，并对我们所持有的与已关停业务相关的个人信息进行删除或匿名化处理。涉及儿童个人信息的，我们会并将停止运营的通知及时告知儿童监护人。<span
      ></span>
    </p>
    <p align="left">
      <span>&nbsp;</span>
    </p>
    <p align="left">
      <b>二、我们如何使用</b><span>&nbsp;<b>Cookie</b>&nbsp;</span
      ><b>和同类技术</b>
    </p>
    <p align="left">
      <b>（一）</b><span>&nbsp;<b>Cookie</b></span>
    </p>
    <p align="left">
      爪玩未来可能会设立为您提供产品及服务的网站，为确保网站正常运转、为您获得更轻松的访问体验、向您推荐您可能感兴趣的内容，我们会在您的计算机或移动设备上存储名<span>Cookie</span>、<span
        >Flash Cookie</span
      >或浏览器或关联应用程序提供的其他通常包含标识符、站点名称以及一些号码和字符的本地存储（统称<span>“Cookie”</span>）。借助于<span>&nbsp;Cookie</span>，网站能够存储您的偏好或购物车内的商品等数据。<span
      ></span>
    </p>
    <p align="left">
      <b>如果您的浏览器或浏览器附加服务允许，您可修改对</b
      ><b><span>Cookie</span></b
      ><b>的接受程度或拒绝我们的</b><b><span>Cookie</span></b
      ><b>。</b
      >有关详情，请参见<span>&nbsp;AboutCookies.org</span>。但如果您这么做，在某些情况下可能会影响您安全访问我们的网站，且可能需要在每一次访问我们的网站时更改用户设置。<span
      ></span>
    </p>
    <p align="left">
      <b>（二）</b><b><span>Cookie</span></b
      ><b>同类技术</b>
    </p>
    <p align="left">
      除<span>&nbsp;Cookie&nbsp;</span>外，我们还会在网站上使用网站信标、像素标签、<span>ETag</span>等其他同类技术。<span
      ></span>
    </p>
    <p align="left">
      例如，我们向您发送的电子邮件可能含有链接至我们网站内容的地址链接，如果您点击该链接，我们则会跟踪此次点击，帮助我们了解您的产品或服务偏好，以便于我们主动改善客户服务体验。网站信标通常是一种嵌入到网站或电子邮件中的透明图像。借助于电子邮件中的像素标签，我们能够获知电子邮件是否被打开。如果您不希望自己的活动以这种方式被追踪，则可以随时从我们的寄信名单中退订。<span
      ></span>
    </p>
    <p align="left">
      <span>&nbsp; &nbsp;ETag</span
      >（实体标签）是在互联网浏览器与互联网服务器之间背后传送的<span>HTTP</span>协议标头，可代替<span>Cookie</span>。<span>ETag</span>可以帮助我们避免不必要的服务器负载，提高服务效率，节省资源、能源，同时，我们可能通过<span>ETag</span>来记录您的身份，以便我们可以更深入地了解和改善我们的产品或服务。<b
        ><u
          >大多数浏览器均为用户提供了清除浏览器缓存数据的功能，您可以在浏览器设置功能中进行相应的数据清除操作。</u
        ></b
      >但请注意，如果停用<span>ETag</span>，您可能无法享受相对更佳的产品或服务体验。<span
        >&nbsp;</span
      >
    </p>
    <p align="left">
      <span>&nbsp;</span>
    </p>
    <p align="left">
      <b>三、我们如何共享、转让、公开披露您的信息</b>
    </p>
    <p align="left">
      <b>（一）共享</b>
    </p>
    <p align="left">
      <span>&nbsp;&nbsp;&nbsp; &nbsp;</span
      >我们不会与爪玩服务提供者以外的公司、组织和个人共享您的个人信息，但以下情况除外：<span
      ></span>
    </p>
    <p align="left">
      <span>1</span
      >、在法定情形下的共享：我们可能会根据法律法规规定、诉讼、争议解决需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息。<span
      ></span>
    </p>
    <p align="left">
      <span>2</span
      >、在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。<span
      ></span>
    </p>
    <p align="left">
      <span>3</span
      >、在您主动选择情况下共享：您通过爪玩购买商品或服务，我们会根据您的选择，将您的订单信息中与交易有关的必要信息共享给相关商品或服务的提供者，以实现您的交易及售后服务需求。
    </p>
    <p align="left">
      4、与关联公司间共享：<b
        ><u
          >为便于我们基于爪玩平台账户向您提供产品和服务，推荐您可能感兴趣的信息，识别会员账号异常，保护爪玩关联公司或其他用户或公众的人身财产安全免遭侵害，您的个人信息可能会与我们的关联公司和</u
        ></b
      ><b
        ><u><span>/</span></u></b
      ><b><u>或其指定的服务提供商共享</u></b
      ><b>。</b
      >我们只会共享必要的个人信息，且受本隐私政策中所声明目的的约束，如果我们共享您的个人敏感信息或关联公司改变个人信息的使用及处理目的，将再次征求您的授权同意。<span
      ></span>
    </p>
    <p align="left">
      5、与授权合作伙伴共享：<b
        ><u>我们可能委托授权合作伙伴为您提供某些服务或代表我们履行职能。</u></b
      >我们仅会出于本隐私权政策声明的合法、正当、必要、特定、明确的目的共享您的信息，授权合作伙伴只能接触到其履行职责所需信息，且不得将此信息用于其他任何目的。对于涉及儿童个人信息的，我们不允许合作伙伴进行转委托。<span
      ></span>
    </p>
    <p align="left">目前，我们的授权合作伙伴包括以下类型：</p>
    <p align="left">
      （<span>1</span>）广告、分析服务类的授权合作伙伴。除非得到您的许可，否则我们不会将您的个人身份信息与提供广告、分析服务的合作伙伴共享。我们会委托这些合作伙伴处理与广告覆盖面和有效性相关的信息，但不会提供您的个人身份信息，或者我们将这些信息进行去标识化处理，以便它不会识别您个人。这类合作伙伴可能将上述信息与他们合法获取的其他数据相结合，以执行我们委托的广告服务或决策建议。<span
      ></span>
    </p>
    <p align="left">
      （<span>2</span>）供应商、服务提供商和其他合作伙伴。我们将信息发送给支持我们业务的供应商、服务提供商和其他合作伙伴，这些支持包括受我们委托提供的技术基础设施服务、分析我们服务的使用方式、衡量广告和服务的有效性、提供客户服务、支付便利或进行学术研究和调查。<span
      ></span>
    </p>
    <p align="left">
      （<span>3</span>）为了使您能够接收信息推送、在第三方平台分享信息、使用地图服务等必要的功能用途，我们的应用中会嵌入授权合作伙伴的<span>SDK</span>或其他类似的应用程序。如您使用华为<span>/</span>小米/OPPO/VIVO/苹果手机时，华为<span>/</span>小米/OPPO/VIVO/苹果手机需要读取您的设备识别号ID或MAC地址、联网相关信息，用于推送<span>/</span>下发通知栏消息；如您使用向微博、微信等第三方平台分享信息功能，相关<span>SDK</span>会收集您的设备识别号、联网相关信息；如您使用高德提供的地图服务，高德<span>SDK</span>需要您打开设备位置权限并收集设备所在位置相关信息信息、设备识别号、联网相关信息；如您使用接收信息推送服务，极光推送/友盟的相关SDK会收集和识别您设备识别号、联网相关信息；我们会对授权合作伙伴获取有关信息的应用程序接口（<span>API</span>）、软件工具开发包（<span>SDK</span>）进行严格的安全检测，并与授权合作伙伴约定严格的数据保护措施，令其按照我们的委托目的、服务说明、本隐私权政策以及其他任何相关的保密和安全措施来处理个人信息。
    </p>
    <p align="left">
      <b>（二）转让</b>
    </p>
    <p align="left">
      我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：<span
      ></span>
    </p>
    <p align="left">
      <span>1</span
      >、在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息。<span
      ></span>
    </p>
    <p align="left">
      <span>2</span
      >、在爪玩服务提供者发生合并、收购或破产清算情形，或其他涉及合并、收购或破产清算情形时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织和个人重新向您征求授权同意。<span
      ></span>
    </p>
    <p align="left">
      <b>（三）公开披露</b>
    </p>
    <p align="left">我们仅会在以下情况下，公开披露您的个人信息：</p>
    <p align="left">
      <span>1</span
      >、获得您明确同意或基于您的主动选择，我们可能会公开披露您的个人信息；<span
      ></span>
    </p>
    <p align="left">
      <span>2</span>、<b
        ><u
          >如果我们确定您出现违反法律法规或严重违反爪玩相关协议及规则的情况，或为保护爪玩及其关联公司用户或公众的人身财产安全免遭侵害，我们可能依据法律法规或爪玩相关协议规则征得您同意的情况下披露关于您的个人信息</u
        ></b
      ><u><span>&nbsp;</span></u
      >，包括相关违规行为以及爪玩已对您采取的措施。
    </p>
    <p align="left">
      <b>（四）共享、转让、公开披露个人信息时事先征得授权同意的例外</b>
    </p>
    <p align="left">
      以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：<span
      ></span>
    </p>
    <p align="left"><span>1</span>、与国家安全、国防安全有关的；</p>
    <p align="left">
      <span>2</span>、与公共安全、公共卫生、重大公共利益有关的；<span></span>
    </p>
    <p align="left">
      <span>3</span
      >、与犯罪侦查、起诉、审判和判决执行等司法或行政执法有关的；<span></span>
    </p>
    <p align="left">
      <span>4</span
      >、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；<span
      ></span>
    </p>
    <p align="left"><span>5</span>、您自行向社会公众公开的个人信息；</p>
    <p align="left">
      <span>6</span
      >、从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。<span
      ></span>
    </p>
    <p align="left">
      请知悉，根据适用的法律，若我们<b
        ><u
          >对个人信息采取技术措施和其他必要措施进行处理，使得数据接收方无法重新识别特定个人且不能复原，则此类处理后数据的共享、转让、公开披露无需另行向您通知并征得您的同意。</u
        ></b
      >
    </p>
    <p align="left">
      <span>&nbsp;</span>
    </p>
    <p align="left">
      <b>四、我们如何保护您的信息</b>
    </p>
    <p align="left">
      （一）我们已采取符合业界标准、合理可行的安全防护措施保护您的个人信息，防止个人信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们会使用加密技术提高个人信息的安全性；我们会使用受信赖的保护机制防止个人信息遭到恶意攻击；我们会部署访问控制机制，尽力确保只有授权人员才可访问个人信息；以及我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。<span
      ></span>
    </p>
    <p align="left">
      我们指定了专人负责儿童信息的保护，严格设定信息访问权限，对可能接触到儿童信息的工作人员采取最小够用授权原则，并采取技术措施对工作人员处理儿童信息的行为进行记录和管控，避免违法复制、下载儿童个人信息。<span
      ></span>
    </p>
    <p align="left">
      （二）我们有行业先进的以数据为核心，围绕数据生命周期进行的数据安全管理体系，从组织建设、制度设计、人员管理、产品技术等方面多维度提升整个系统的安全性。
    </p>
    <p align="left">
      （三）我们会采取合理可行的措施，尽力避免收集无关的个人信息。<b
        ><u
          >我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非法律有强制的存留要求。</u
        ></b
      >例如《中华人民共和国电子商务法》要求商品和服务信息、交易信息保存时间自交易完成之日起不少于三年。而我们判断前述期限的标准包括：<span
      ></span>
    </p>
    <p align="left">
      <span>1</span
      >、完成与您相关的交易目的、维护相应交易及业务记录、应对您可能的查询或投诉；<span
      ></span>
    </p>
    <p align="left">
      <span>2</span>、保证我们为您提供服务的安全和质量；<span></span>
    </p>
    <p align="left"><span>3</span>、您是否同意更长的留存期间；</p>
    <p align="left"><span>4</span>、是否存在保留期限的其他特别约定。</p>
    <p align="left">
      <b
        ><u
          >在您的个人信息超出保留期间后，我们会根据适用法律的要求删除您的个人信息，或使其匿名化处理。</u
        ></b
      >
    </p>
    <p align="left">
      <span>&nbsp; &nbsp;</span
      >（四）互联网并非绝对安全的环境，使用爪玩服务时，<b
        ><u>我们强烈建议您不要使用非爪玩推荐的通信方式发送您的信息</u></b
      ><u><span>&nbsp;</span></u
      >。您可以通过我们的服务建立联系和相互分享。当您通过我们的服务创建交流、交易或分享时，您可以自主选择沟通、交易或分享的对象，作为能够看到您的交易内容、联络方式、交流信息或分享内容等相关信息的第三方。<span
      ></span>
    </p>
    <p align="left">
      在使用爪玩服务进行网上交易时，您不可避免地要向交易对方或潜在的交易对方披露自己的个人信息，如联络方式或联系地址。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息尤其是您的账号或密码发生泄露，请您立即联络爪玩，以便我们根据您的申请采取相应措施。<span
      ></span>
    </p>
    <p align="left">
      请注意，您在使用我们服务时自愿共享甚至公开分享的信息，可能会涉及您或他人的个人信息甚至个人敏感信息。请您更加谨慎地考虑，是否在使用我们的服务时共享甚至公开分享相关信息。<span
      ></span>
    </p>
    <p align="left">
      请使用复杂密码，协助我们保证您的账号安全。我们将尽力保障您发送给我们的任何信息的安全性。如果我们的物理、技术或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。<span
      ></span>
    </p>
    <p align="left">
      （五）我们将不定期更新并公开安全风险、个人信息安全影响评估报告等有关内容，您可通过爪玩公告方式获得。<span
      ></span>
    </p>
    <p align="left">
      （六）在不幸发生个人信息安全事件后，我们将按照法律法规的要求向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。事件相关情况我们将以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。<span
      ></span>
    </p>
    <p align="left">
      我们已制定儿童信息安全事件应急预案，定期组织内部相关人员进行应急响应培训和应急演练，使其掌握岗位职责和应急处置策略和规程。在不幸发生儿童信息安全事件后，我们将按照法律法规的要求，及时向儿童及其监护人告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、儿童及其监护人可自主防范和降低风险的建议、对儿童及其监护人的补救措施等。我们将及时将事件相关情况以<span>APP</span>推送通知、发送短消息等方式告知儿童及其监护人。难以逐一告知时，我们会采取合理、有效的方式发布相关警示信息。同时，我们还将按照监管部门要求，主动上报儿童信息安全事件的处置情况。若儿童及其监护人的合法权益受损，我们将承担相应的法律责任。<span
      ></span>
    </p>
    <p align="left">
      同时，我们还将按照监管部门要求，上报个人信息安全事件的处置情况。<span
      ></span>
    </p>
    <p align="left">
      <span>&nbsp;</span>
    </p>
    <p align="left">
      <b>五、您如何管理您的信息</b>
    </p>
    <p align="left">您可以通过以下方式访问及管理您的个人信息：</p>
    <p align="left">
      <b>（一）查询您的信息</b>
    </p>
    <p align="left">
      您有权查询您的信息，法律法规规定的例外情况除外。您可以通过以下方式自行访问您的个人信息：<span
      ></span>
    </p>
    <p align="left">
      账号信息<span>——</span>如果您希望访问或编辑您的账号中的个人基本资料信息，您可以通过爪玩移动客户端登录账号执行此类操作。<span
      ></span>
    </p>
    <p align="left">
      搜索信息<span>——</span>您可以访问或清除您的搜索历史记录。<span></span>
    </p>
    <p align="left">
      订单信息：您可以在爪玩查阅您的订单记录、交易记录等。<span></span>
    </p>
    <p align="left">
      如果您无法通过上述路径访问该等个人信息，您可以与爪玩客服取得联系。<span
      ></span>
    </p>
    <p align="left">
      对于您在使用我们的产品或服务过程中产生的其他个人信息，我们将根据本条的<span>“</span>（七）响应您的上述请求<span>”</span>中的相关安排向您提供。<span
      ></span>
    </p>
    <p align="left">
      <b>（二）更正或补充您的个人信息</b>
    </p>
    <p align="left">
      当您发现我们处理的关于您的个人信息有错误时，您有权要求我们做出更正或补充。您可以通过<span>“</span>（一）访问您的个人信息<span>”</span>中列明的方式提出更正或补充申请。<span
      ></span>
    </p>
    <p align="left">
      <b>（三）删除您的个人信息</b>
    </p>
    <p align="left">
      您可以通过<span>“</span>（一）访问您的个人信息<span>”</span>中列明的方式删除您的部分个人信息。<span
      ></span>
    </p>
    <p align="left">
      在以下情形中，您可以向我们提出删除个人信息的请求：<span></span>
    </p>
    <p align="left">
      <span>1</span>、如果我们处理个人信息的行为违反法律法规；<span></span>
    </p>
    <p align="left">
      <span>2</span
      >、如果我们收集、使用您的个人信息，却未征得您的明确同意；<span></span>
    </p>
    <p align="left">
      <span>3</span>、如果我们处理个人信息的行为严重违反了与您的约定；<span
      ></span>
    </p>
    <p align="left">
      <span>4</span
      >、如果您不再使用我们的产品或服务，或您主动注销了爪玩平台账户；<span
      ></span>
    </p>
    <p align="left">
      <span>5</span>、如果我们永久不再为您提供产品或服务。<span></span>
    </p>
    <p align="left">
      若我们决定响应您的删除请求，我们还将同时尽可能通知从我们处获得您的个人信息的主体，并要求其及时删除，除非法律法规另有规定，或这些主体已获得您的授权。<span
      ></span>
    </p>
    <p align="left">
      <b
        ><u
          >当您或我们协助您删除相关信息后，因为适用的法律和安全技术，我们可能无法立即从备份系统中删除相应的信息，我们将安全地存储您的个人信息并将其与任何进一步处理隔离，直到备份可以清除或实现匿名。</u
        ></b
      >
    </p>
    <p align="left">
      <b>（四）改变您授权同意的范围</b>
    </p>
    <p align="left">
      每个业务功能可能需要一些基本的个人信息才能得以完成（见本隐私权政策<span>“</span>第二部分第一条<span>”</span>）。除此之外，对于额外个人信息的收集和使用，您可以与爪玩客服联系给予或收回您的授权同意。<span
      ></span>
    </p>
    <p align="left">
      当您收回同意后，我们将不再处理相应的个人信息。<b
        ><u
          >但您收回同意的决定，不会影响此前基于您的授权而开展的个人信息处理</u
        ></b
      ><u><span>&nbsp;</span></u
      >。
    </p>
    <p align="left">
      <b>（五）注销您的的账户</b>
    </p>
    <p align="left">
      我们通过爪玩平台账户为您提供爪玩产品或者服务，如您需要注销您的账号，可以通过以下方式注销您的账户：<span
      ></span>
    </p>
    <p align="left">
      <span>1</span
      >、登录手机爪玩客户端，通过<span>“</span>我的<span>-</span>设置<span>-</span>注销账号<span>”</span>提交账户注销申请；<span
      ></span>
    </p>
    <p align="left">
      <span>2</span
      >、登录爪玩移动客户端并选择<span>“</span>我的<span>-</span>设置<span>-</span>联系我们<span>”</span>寻求帮助，协助您申请注销您的账户。<span
      ></span>
    </p>
    <p align="left">
      在您主动注销您的账户之后，我们将停止为您提供产品或服务，根据适用法律的要求删除您的个人信息，或使其匿名化处理。<span
      ></span>
    </p>
    <p align="left">
      <b>（六）约束信息系统自动决策</b>
    </p>
    <p align="left">
      在某些业务功能中，我们可能仅依据信息系统、算法等在内的非人工自动决策机制做出决定。如果这些决定显著影响您的合法权益，您有权要求我们做出解释，我们也将在不侵害爪玩商业秘密或其他用户权益、社会公共利益的前提下提供申诉方法。<span
      ></span>
    </p>
    <p align="left">
      <b>（七）响应您的上述请求</b>
    </p>
    <p align="left">
      为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。<span
      ></span>
    </p>
    <p align="left">
      我们将在<span>15</span>天内做出答复。如您不满意，还可以通过爪玩客服发起投诉。<span
      ></span>
    </p>
    <p align="left">
      对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将酌情收取一定费用。对于与您的身份不直接关联的信息、无端重复信息，或者需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者不切实际的请求，我们可能会予以拒绝。<span
      ></span>
    </p>
    <p align="left">
      在以下情形中，按照法律法规要求，我们将无法响应您的请求：<span></span>
    </p>
    <p align="left"><span>1</span>、与国家安全、国防安全有关的；</p>
    <p align="left">
      <span>2</span>、与公共安全、公共卫生、重大公共利益有关的；<span></span>
    </p>
    <p align="left">
      <span>3</span>、与犯罪侦查、起诉、审判和执行判决等有关的；<span></span>
    </p>
    <p align="left">
      <span>4</span>、有充分证据表明个人信息主体存在主观恶意或滥用权利的；<span
      ></span>
    </p>
    <p align="left">
      <span>5</span
      >、响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；<span
      ></span>
    </p>
    <p align="left"><span>6</span>、涉及商业秘密的。</p>
    <p align="left">
      <span>&nbsp;</span>
    </p>
    <p align="left">
      <b>六、我们如何处理未成年人的信息</b>
    </p>
    <p align="left">
      <b
        ><u
          >在使用爪玩中我们推定您具有相应的民事行为能力。如您为未成年人，我们要求您请您的父母或其他监护人仔细阅读本隐私权政策，并在征得您的父母或其他监护人同意的前提下使用我们的服务或向我们提供信息。</u
        ></b
      >
    </p>
    <p align="left">
      <b
        ><u
          >一旦我们识别出您是儿童用户的，我们将通知您的监护人并要求您的监护人同意儿童个人信息收集使用规则。</u
        ></b
      >对于经父母或其他监护人同意使用我们的产品或服务而收集儿童个人信息的情况，我们只会在法律法规允许、父母或其他监护人明确同意或者保护儿童所必要的情况下使用、共享、转让或披露此信息。<span
      ></span>
    </p>
    <p align="left">
      若您是儿童的父母或其他监护人，请您关注您监护的儿童是否是在取得您的授权同意之后使用我们的服务。如您对您所监护的儿童的个人信息有疑问，请通过第九节中的联系方式与我们联系。<span
      ></span>
    </p>
    <p align="left">
      <span>&nbsp;</span>
    </p>
    <p align="left">
      <b>七、您的信息如何在全球范围转移</b>
    </p>
    <p align="left">
      我们在中华人民共和国境内运营中收集和产生的个人信息，存储在中国境内，以下情形除外：<span
      ></span>
    </p>
    <p align="left"><span>1</span>、适用的法律有明确规定；</p>
    <p align="left"><span>2</span>、获得您的明确授权；</p>
    <p align="left">
      <span>3</span>、您通过互联网进行跨境交易等个人主动行为。<span></span>
    </p>
    <p align="left">
      针对以上情形，我们会确保依据本隐私权政策对您的个人信息提供足够的保护。<span
      ></span>
    </p>
    <p align="left">
      <span>&nbsp;</span>
    </p>
    <p align="left">
      <b>八、本隐私权政策如何更新</b>
    </p>
    <p align="left">我们的隐私权政策可能变更。</p>
    <p align="left">
      未经您明确同意，我们不会限制您按照本隐私权政策所应享有的权利。我们会在专门页面发布对隐私政策所做的任何变更。<span
      ></span>
    </p>
    <p align="left">
      对于重大变更，我们还会提供更为显著的通知（包括我们会通过爪玩移动客户端公示的方式进行通知甚至向您提供弹窗提示）。<span
      ></span>
    </p>
    <p align="left">本政策所指的重大变更包括但不限于：</p>
    <p align="left">
      <span>1</span
      >、我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；<span
      ></span>
    </p>
    <p align="left">
      <span>2</span
      >、我们在控制权等方面发生重大变化。如并购重组等引起的信息控制者变更等；<span
      ></span>
    </p>
    <p align="left">
      <span>3</span>、个人信息共享、转让或公开披露的主要对象发生变化；<span
      ></span>
    </p>
    <p align="left">
      <span>4</span
      >、您参与个人信息处理方面的权利及其行使方式发生重大变化；<span></span>
    </p>
    <p align="left">
      <span>5</span
      >、我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；<span
      ></span>
    </p>
    <p align="left">
      <span>6</span>、个人信息安全影响评估报告表明存在高风险。<span></span>
    </p>
    <p align="left">
      <span>&nbsp;</span>
    </p>
    <p align="left">
      <b>九、如何联系我们</b>
    </p>
    <p align="left">
      您可以通过以下方式与我们联系，我们将在<span>15</span>天内回复您的请求：<span
      ></span>
    </p>
    <p align="left">
      <span>1</span
      >、如对本政策内容、儿童个人信息有任何疑问、意见或建议，您可通过爪玩客服与我们联系；<span
      ></span>
    </p>
    <p align="left">
      <span>2</span
      >、如果您对我们的回复不满意，特别是您认为我们的个人信息处理行为损害了您的合法权益，<b
        ><u>您还可以</u></b
      ><u><span>&nbsp;</span></u
      ><b
        ><u
          >向下述仲裁机构提起仲裁，并按照仲裁申请时中国国际经济贸易仲裁委员会现行有效的仲裁规则进行裁决。仲裁裁决是终局的，对双方均有约束力：</u
        ></b
      >
    </p>
    <p align="left">
      <span>1)&nbsp;&nbsp;&nbsp;&nbsp;</span
      ><b>您登记的个人资料或收货地址或联系地址或订单成交时的网路</b
      ><b><span>IP</span></b
      ><b
        >地址在西安的，提交中国国际经济贸易仲裁委员会西安分会（仲裁中心）进行裁决；</b
      >
    </p>
    <p align="left">
      <span>2)&nbsp;&nbsp;&nbsp;&nbsp;</span
      ><b>您登记的个人资料或收货地址或联系地址或订单成交时的网路</b
      ><b><span>IP</span></b
      ><b
        >地址在华南地区（指：中华人民共和国广东、广西、海南三省）的，提交中国国际经济贸易仲裁委员会华南分会（仲裁中心）进行裁决；</b
      >
    </p>
    <p align="left">
      <span>3)&nbsp;&nbsp;&nbsp;&nbsp;</span
      ><b>您登记的个人资料或收货地址或联系地址或订单成交时的网路</b
      ><b><span>IP</span></b
      ><b
        >地址在华北地区（指：中华人民共和国陕西、山西、河北、北京、天津、山东、黑龙江、吉林、辽宁等省市）的，提交中国国际经济贸易仲裁委员会天津分会（仲裁中心）进行裁决；</b
      >
    </p>
    <p align="left">
      <span>4)&nbsp;&nbsp;&nbsp;&nbsp;</span
      ><b>您登记的个人资料或收货地址或联系地址或订单成交时的网路</b
      ><b><span>IP</span></b
      ><b
        >地址在西南地区（指：中华人民共和国云南、四川、贵州、重庆等省市）的，提交中国国际经济贸易仲裁委员会西南分会（仲裁中心）进行裁决；</b
      ><span>&nbsp;</span>
    </p>
    <p align="left">
      <span>5)&nbsp;&nbsp;&nbsp;&nbsp;</span
      ><b>您登记的个人资料或收货地址或联系地址或订单成交时的网路</b
      ><b><span>IP</span></b
      ><b
        >地址在华东地区的（指：中华人民共和国江苏、安徽、浙江、福建四省），提交中国国际经济贸易仲裁委员会浙江分会（仲裁中心）进行裁决；</b
      ><span>&nbsp;</span>
    </p>
    <p align="left">
      <span>6)&nbsp;&nbsp;&nbsp;&nbsp;</span
      ><b>您登记的个人资料或收货地址或联系地址或订单成交时的网路</b
      ><b><span>IP</span></b
      ><b
        >地址在华中地区（指：中华人民共和国河南、湖北、湖南、江西四省）的，提交中国国际经济贸易仲裁委员会湖北分会（仲裁中心）进行裁决；</b
      ><span>&nbsp;</span>
    </p>
    <p align="left">
      <span>7)&nbsp;&nbsp;&nbsp;&nbsp;</span
      ><b>您登记的个人资料或收货地址或联系地址或订单成交时的网路</b
      ><b><span>IP</span></b
      ><b
        >地址在上述以外地区的，提交中国国际经济贸易仲裁委员会西安分会（仲裁中心）进行裁决。</b
      >
    </p>
    <p align="left">
      <span>&nbsp;</span>
    </p>
    <p align="left">
      <span>&nbsp;</span>
    </p>
    <p align="left">
      <span>&nbsp;</span>
    </p>
    <p>
      <span></span>
    </p>
  </div>
</template>

<script>
export default {
  mounted() {
    document.title = '隐私政策'
  },
}
</script>

<style lang="less" scoped>
.page {
  padding: 10px;
  .title {
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    margin: 20px 0;
  }
  p {
    text-align: justify;
    font-size: 12px;
    color: #333;
  }
  .time {
    text-align: right;
  }
  table {
    tr {
      th {
        font-size: 14px;
      }
    }
    tr {
      td {
        font-size: 12px;
      }
    }
  }
}
</style>
